import { CustomMeetYourHerbsState } from "@gaiaProfessionals/Store/MeetYourHerbs/GAIAMeetYourHerbsReducer";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import { getCurrentUserIsGuest } from "@insite/client-framework/Store/Context/ContextSelectors";
import { WidgetGroup } from "@insite/client-framework/Types/WidgetGroups";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: CustomMeetYourHerbsState) => ({
    productTitle: state.customMeetYourHerbsReducer?.productData?.productTitle,
    userName: state.context.session.userName,
    url: state.customMeetYourHerbsReducer?.productData?.canonicalUrl,
    currentUserIsGuest: getCurrentUserIsGuest(state),
});

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & HasHistory;

export interface GAIAMYHReadyToPurchaseStyles {
    mainWrapper?: InjectableCss;
    readyToPurchaseText?: TypographyProps;
    shopNowBtn?: ButtonPresentationProps;
}
const styles: GAIAMYHReadyToPurchaseStyles = {
    mainWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            padding: 50px 10px;
            text-align: center;
            background: #205C40;
            
        `,
    },
    readyToPurchaseText: {
        variant: "h2",
        color: "#fff",
        size: 32,
        css: css``,
    },
    shopNowBtn: {
        css: css`
        border: 2px solid #fff;
        `,
    }
};

const GAIAMYHReadyToPurchase: React.FC<Props> = ({ id, productTitle, userName, currentUserIsGuest, history, url }) => {
    const redirectToShopUrl = () => {
        if (url) {
            history.push(url)
        }
    }
    return (
        <StyledWrapper {...styles.mainWrapper}>
            <Typography {...styles.readyToPurchaseText}>
                Ready to purchase <Typography>{productTitle}</Typography>?
            </Typography>
            {
                (!userName || currentUserIsGuest) ?
                    <Zone contentId={id} zoneName="Content0" /> :
                    <Button onClick={redirectToShopUrl} {...styles.shopNowBtn}>Shop Now</Button>
            }


        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withHistory(GAIAMYHReadyToPurchase)),
    definition: {
        displayName: "MYH Ready To Purchase",
        group: "MYH Product Details" as WidgetGroup,
    },
};

export default widgetModule;
